import React, { Component } from 'react';
import {ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'
import moment from 'moment'

import SelectMainProduct from './SelectMainProduct'
import SelectBendedProduct from './SelectBendedProduct'
import SelectMiscellaneousProduct from './SelectMiscellaneousProduct'
import SelectHardwareProduct from './SelectHardwareProduct'

import Print from './Print'
import QMainProduct from './QMainProduct'
import QBended from './QBended'
import QHardware from './QHardware'
import QMiscellaneous from './QMiscellaneous'


class Quotation extends Component {

    constructor(){
        super();
        this.press = this.press.bind(this);
        this.getTotal = this.getTotal.bind(this);
        this.getTotal2 = this.getTotal2.bind(this);
        this.handleDelivery = this.handleDelivery.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setItem =this.setItem.bind(this)
        this.setThickness =this.setThickness.bind(this)
        this.removeTotal = this.removeTotal.bind(this)
        this.removeTotal2 = this.removeTotal2.bind(this)
        

        this.state={
            total : {},
            total2 : {},
            totalValue : 0,
            totalValue2 : 0,
            temp : {},
            deliveryCharge : 0,
            customerData : {},
            item : "",
            thickness : "",
            discount : 0,
            sample : {},
            quoteNumber : 100000
            
        }
        
    }
    componentWillMount(){
        
        
        ref.child("Quotation").limitToLast(1).on("value", function(childSnapshot) {
            childSnapshot.forEach(function(data) {
                this.setState({
                    quoteNumber : parseInt(data.key,10) + parseInt(1,10)
                })
            }.bind(this))
        }.bind(this));

        ref.child("Quotation").limitToLast(1).on("child_added", function(childSnapshot) {
            childSnapshot.forEach(function(data) {
                this.setState({
                    quoteNumber : parseInt(data.key,10) + parseInt(1,10)
                })
            }.bind(this))
        }.bind(this));
    

    }
    getTotal(index,data){

        let total = {...this.state.total}
            total[index]={
                data : parseInt(data,10)
            }

            this.setState({
                total
            }) 
        

    }

    getTotal2(index,data){

        let total2 = {...this.state.total2}
            total2[index]={
                data : parseInt(data,10)
            }

            this.setState({
                total2
            }) 
        

    }
    
    removeTotal(index){
        let stateTotal = this.state.total

        delete stateTotal[index]
        
        let ids = Object.keys(this.state.total)
        let total = ids.reduce((prevTotal,key)=>{
            let value = this.state.total[key]
            return prevTotal + value.data
        },0)
        this.setState({
            totalValue :total.toFixed(2)
        })

        this.setState({total : stateTotal})    

    }

     removeTotal2(index){
        let stateTotal = this.state.total2

        delete stateTotal[index]
        
        let ids = Object.keys(this.state.total2)
        let total = ids.reduce((prevTotal,key)=>{
            let value = this.state.total2[key]
            return prevTotal + value.data
        },0)
        this.setState({
            totalValue2 :total.toFixed(2)
        })

        this.setState({total2 : stateTotal})    

    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.total !== this.state.total){

            let ids = Object.keys(this.state.total)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.total[key]
                return prevTotal + value.data
            },0)
            this.setState({
                totalValue :total.toFixed(2)
            })
            
            
        }
        if(prevState.total2 !== this.state.total2){
            let ids = Object.keys(this.state.total2)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.total2[key]
                return prevTotal + value.data
            },0)
            //total = total.toFixed(2)
            this.setState({
                totalValue2 :total.toFixed(2)
            })
        }
        
    }

    handleDelivery(e){
        
        let amount = e.target.value
        this.setState({
            deliveryCharge : amount
        })
    }

    handleSubmit(e){
        e.preventDefault()
        let refer = this.refs
        Object.keys(refer).map((key)=>{
            let temp = this.state.temp
                temp[key] = {
                    productId : refer[key].productId.value,
                    category : refer[key].category.value,
                    productName : refer[key].productName.value,
                    productDimension : refer[key].productDimension.value,
                    productThickness : refer[key].productThickness.value,
                    productNumber : refer[key].productNumber.value,
                    productPrice : refer[key].productPrice.value,
                    productUnit : refer[key].productUnit.value,
                    productDiscount : refer[key].productDiscount.value,
                    productTotal : refer[key].productTotal.value
                }
                this.setState({temp})             
                
        })
          
            let customerData ={
                    name : this.customerName.value,
                    number : this.contactNumber.value,
                    project : this.project.value,
                    reference : this.reference.value,
                    location : this.location.value,
                    representative : this.salesRepName.value,
                    item : this.state.item,
                    thickness : this.state.thickness,
                    sched : this.sched.value,
                    eta : this.eta.value
                }

            let cornersData = {
                    cornerQty : this.props.cornerQty,
                    cornerPrice : this.props.cornerPrice,
                    cornerDis : this.props.cornerDis,
                    cornerTotal : this.props.cornerTotal
            }
            
        let saveData = {
            userId : this.props.userId,
            quoteDate : this.quoteDate.value,
            quoteNumber : this.quoteNumber.value,
            customer : customerData, 
            products : this.state.temp,
            labor : this.props.totalLabor,
            totalValue :this.state.totalValue,
            totalValue2 : this.state.totalValue2,
            laborCost : this.props.totalLaborValue,
            totalMaterials : this.totalMaterials.value,
            totalQuote : this.totalQuote.value,
            deliveryCharge : this.deliveryCharge.value,
            corners : cornersData,
            status : "Pending"
        }

        ref.child("Quotation").child(this.quoteNumber.value).set(saveData)
        .then( alert("New Quotation has been added!"))
        if(this.props.user.role==="Admin"){
         window.location.assign("/quotation/pending")
        }else{
           window.location.assign("/quotation/pendingU") 
        }
        
        this.formSubmit.reset();
    }

    setItem(item){
        this.setState({
            item : item
        })
    }
    setThickness(thick){
        this.setState({
            thickness : thick
        })
    }

    press(e){
         if (e.which === 13 /* Enter */) {
                e.preventDefault();
            }
    }

   
    render() {
            //var sum = 0
            var totalMaterials = parseInt(this.state.totalValue,10) + parseInt(this.state.totalValue2,10)
            var totalQuote = parseInt(totalMaterials,10)  + parseInt(this.state.deliveryCharge,10) 
            var salesName = this.props.user.firstname + " " + this.props.user.lastname
        return (

            <div>
                <div id="react-no-print">                                                
                    <form className="form-horizontal form-bordered"  ref={input => this.formSubmit = input} onSubmit={this.handleSubmit} onKeyPress={this.press}>
                        <em><p className="text-right getComputerDate">Date: {moment().format("MMMM DD, YYYY")}<input type="hidden" ref={ input => this.quoteDate = input } value ={moment().format("MMMM DD, YYYY")} /></p></em>
                        <p className="text-right getComputerDate">Quotation Number: <input type="text" ref={ input => this.quoteNumber = input } value={this.state.quoteNumber}/></p>
                        <h3 className="text-center paddingLeft20px">Customer Information</h3>
                            <div className="row">    
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Customer / Company Name</label>
                                    <div className="col-md-12">
                                        <input className="form-control text-uppercase"  ref={ input => this.customerName = input }  type="text" required/>
                                    </div>
                                </div>
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Contact Number</label>
                                    <div className="col-md-12">
                                        <input className="form-control text-uppercase"  ref={ input => this.contactNumber = input } type="text" required/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">    
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Project</label>
                                    <div className="col-md-12">
                                        <input className="form-control text-uppercase"   ref={ input => this.project = input } type="text" required/>
                                    </div>
                                </div>
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Reference</label>
                                    <div className="col-md-12">
                                        <select className="form-control text-uppercase" name="length" ref={ input => this.reference=input } >
                                            <option>Select Reference</option>
                                            <option value="Actual Measurement">Actual Measurement</option>
                                            <option value="Given Quantity">Given Quantity</option>
                                            <option value="Based on Plan">Based on Plan</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">    
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Location / Delivery Site</label>
                                    <div className="col-md-12">
                                        <input className="form-control text-uppercase"  ref={ input => this.location = input  } type="text" required/>
                                    </div>
                                </div>
                                <div className="form-group col-md-6 addQuoteField">
                                    <label className="col-md-12 control-label text-uppercase" >Sales Representative</label>
                                    <div className="col-md-12">
                                        <input className="form-control text-uppercase"  ref={ input => this.salesRepName = input } value={salesName} type="text" />
                                    </div>
                                </div>
                            </div>                                                                  
                            
                            <h3 className="text-left paddingLeft20px text-uppercase">Sales Contract</h3>
                            <div className="forMobileWrap">
                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px text-uppercase"><strong>Roof Type</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="BendedAccessoriesTrow">
                                                <th className="text-left forRoofType text-uppercase">Product Name</th>
                                                <th className="text-left forDimension text-uppercase">Dimension</th>
                                                <th className="text-left forThickness text-uppercase">Thickness</th>
                                                <th className="text-center forLengthSize text-uppercase">Quantity</th>
                                                <th className="text-center forUnitType text-uppercase">Unit</th>
                                                <th className="text-center forPriceValue text-uppercase">Price</th>
                                                <th className="text-center forUnitDesc text-uppercase">Per Unit</th>
                                                <th className="text-center forUnitDesc text-uppercase">Discount</th>
                                                <th className="text-center forAreaValue text-uppercase">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            { 
                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Main Product"){                                                   
                                                            //console.log(list)
                                                            return <QMainProduct ref={key} key={key} index={key} product ={list.product} 
                                                                     setProductsLabor={this.props.setProductsLabor} getTotal={this.getTotal}
                                                                     setItem={this.setItem} setThickness = {this.setThickness} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal}/>                                                    
                                                           }
                                                    }.bind(this))

                                            }
                                            <SelectMainProduct setList ={this.props.setList}/>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Bended Accessories</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="BendedAccessoriesTrow">
                                                <th className="text-center forRoofType text-uppercase"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {

                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Bended Accessories"){                                                   
                                                            
                                                            return <QBended ref={key} key={key} index={key} product ={list.product}  
                                                                    setProductsLabor={this.props.setProductsLabor} getTotal={this.getTotal} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal} />                                                    
                                                           }
                                                    }.bind(this))

                                            }
                                            <SelectBendedProduct setList ={this.props.setList}/>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td className="text-uppercase">Subtotal</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(this.state.totalValue)
                                                    }
                                                </td>
                                            </tr> 
                                                                                                                    
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Miscellaneous</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="BendedAccessoriesTrow">
                                                <th className="text-center forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {  

                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Miscellaneous"){                                                   
                                                            
                                                            return <QMiscellaneous ref={key} key={key} index={key} product ={list.product}
                                                            setProductsLabor={this.props.setProductsLabor} getTotal2={this.getTotal2} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal2} />                                                    
                                                           }
                                                    }.bind(this))  
                                
                                            }
                                            <SelectMiscellaneousProduct setList ={this.props.setList}/>                                    
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Hardware Accessories</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="BendedAccessoriesTrow">
                                                <th className="text-center forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {    
                                                
                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Hardware Accessories"){                                                   
                                                            
                                                            return <QHardware ref={key} key={key} index={key} product ={list.product} getTotal2={this.getTotal2} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal2} />                                                    
                                                           }
                                                    }.bind(this))

                                            }
                                            <SelectHardwareProduct setList ={this.props.setList}/>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td className="text-uppercase">Subtotal</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(this.state.totalValue2)
                                                    }
                                                </td>
                                            </tr>          
                                        </tbody>                                            
                                    </table>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="BendedAccessoriesTrow">
                                                <th className="text-center forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td className="text-uppercase">Total Materials</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(totalMaterials)
                                                    }
                                                    <input type="hidden" className="form-control" value={totalMaterials.toFixed(2)} name="totalMaterials" ref={input => this.totalMaterials = input}   />
                                                </td>
                                            </tr>                                                
                                            
                                            <tr>
                                                <td><input className="form-control text-uppercase"  ref={ input => this.sched = input }  placeholder="DELIVERY SCHEDULE: (ex. 10 - 15 working days. )" type="text" /></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>                                                
                                                <td></td>
                                                <td className="text-uppercase">Delivery Charge</td>
                                                <td>
                                                   <input type="text" className="form-control"  name="deliveryCharge" ref={input => this.deliveryCharge = input}  onChange={this.handleDelivery} value={this.state.deliveryCharge}/>
                                                </td>                                                
                                            </tr>
                                            <tr className="grandTotalTdRow">
                                                <td><input className="form-control text-uppercase"  ref={ input => this.eta = input }  placeholder="ETA: (ex. around 9:00am)" type="text" /></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td className="grandTotal">Grand Total</td>
                                                <td className="grandTotal">
                                                    {
                                                        formatPrice(totalQuote)
                                                    }
                                                   <input type="hidden" className="form-control"  name="totalQuote" ref={input => this.totalQuote = input}  value={totalQuote.toFixed(2)} />
                                                </td>                                                
                                            </tr>                  
                                        </tbody>                                            
                                    </table>
                                    <div className="submitContract text-center">
                                       <button type="submit" className="btn btn-primary"><i className="fa fa-floppy-o" aria-hidden="true"></i> Save Quotation</button>
                                    </div>
                                </div>

                            </div>
                            
                       </form> 
                    </div>      
                </div>
                                 
        );
    }
}

export default Quotation;



// WEBPACK FOOTER //
// ./src/components/Quotation.js